function TempService() {
    this.store = function (id, value, permanently) {
        TempService.dataStore[id] = {
            value: value,
            permanently: permanently
        };
    };

    this.get = function (id) {
        var data = TempService.dataStore[id];
        if (data) {
            if (!data.permanently)
                TempService.dataStore[id] = undefined;
            return data.value;
        }
        else
            return undefined;
    }
}

TempService.dataStore = {};

angular.module('eficienciaFiscalModule').service('tempService', TempService);
